import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DashboardCard from "../../components/Dashboard-card";
import Footer from "../../layouts/Dashboard/Footer";
import Header from "../../layouts/Dashboard/Header";
import HeroSection from "../../layouts/Dashboard/Herosection";
import Profile from "../../layouts/Dashboard/Profile";
import { fontstyle1 } from "../../utils/fonts";
import ThemeContext from "../../context";
import ColorsTheme from "../../utils/colors";
import history from "../../utils/history";
import instance from "../../utils/axios";

const Dashboard = () => {
  const [data, setData] = useState([]);

  const id = useParams().id;

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") !== null
      ? localStorage.getItem("theme")
      : "light"
  );

  const value = { theme, setTheme };
  const colortheme = theme === "light" ? ColorsTheme.light : ColorsTheme.dark;

  useEffect(() => {
    if (
      localStorage.getItem("dofeedbackin_email") === "" &&
      localStorage.getItem("dofeedbackin_token") === ""
    ) {
      history.push("/");
      history.go();
    }
    getProjects();
  }, []);

  const getProjects = () => {
    instance
      .post("/getprojects", {
        uid: localStorage.getItem("dofeedbackin_uid")
      })
      .then((res) => {
        setData(res.data.data);
      });
  };

  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center"
      style={{
        background: colortheme.background,
        color: colortheme.color
      }}
    >
      <ThemeContext.Provider value={value}>
        <div className="w-[80%]">
          <Header />
          <div
            className={`w-full ${
              data.length === 0 ? "h-[100vh]" : "h-[100%]"
            } flex flex-col items-center justify-between`}
          >
            <HeroSection />
            {data.length === 0 ? (
              <div style={fontstyle1}>Create new project</div>
            ) : (
              <div className="w-full flex items-start justify-center sm:justify-start flex-wrap gap-5 pt-10 pb-10">
                {data.map((item) => (
                  <DashboardCard
                    name={item.projectname}
                    pid={item.projectid}
                    date={item.created_at}
                    id={id}
                  />
                ))}
              </div>
            )}
            <div className="flex flex-col items-center justify-center">
              <Profile />
              <Footer />
            </div>
          </div>
        </div>
      </ThemeContext.Provider>
    </div>
  );
};

export default Dashboard;
